
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class RazorPaySettingsDialog extends Serenity.EntityDialog<RazorPaySettingsRow, any> {
        protected getFormKey() { return RazorPaySettingsForm.formKey; }
        protected getIdProperty() { return RazorPaySettingsRow.idProperty; }
        protected getLocalTextPrefix() { return RazorPaySettingsRow.localTextPrefix; }
        protected getNameProperty() { return RazorPaySettingsRow.nameProperty; }
        protected getService() { return RazorPaySettingsService.baseUrl; }
        protected getDeletePermission() { return RazorPaySettingsRow.deletePermission; }
        protected getInsertPermission() { return RazorPaySettingsRow.insertPermission; }
        protected getUpdatePermission() { return RazorPaySettingsRow.updatePermission; }

        protected form = new RazorPaySettingsForm(this.idPrefix);

    }
}
